import moment from 'moment';

const EST_DATE_FORMAT = 'MM/DD/YYYY';

export const isTimestampExpired = (exp) => exp < moment().unix();

export const isValidDate = date => moment(date).isValid();

export const formatToEstDate = date => moment(date).format(EST_DATE_FORMAT);